import {Box, Menu, styled} from "@mui/material";
import React, {useState} from "react";
import {team} from "../../config/roadmap";

interface RoadmapElInterface {
    top: boolean;
    title: string;
    points: string[]
}

const RoadmapElPrime = styled(Box)({
    height: "300px",
    background: "rgba(0, 0, 0, 0.6)",
    borderRadius: "8px",
    padding: "15px",
    position: "relative",
    "& li": {
        whiteSpace: "break-spaces",
        marginTop: "10px",
        fontSize: "1.3rem",
        fontWeight: 400,
        color: "#FFFFFF",
        zIndex: 2,
        textShadow: "1px 1px 2px black, 0 0 25px black, 0 0 5px black",
        "@media(max-width: 768px)": {
            fontSize: "0.8rem",
        },
    },
    "& a":{
        color: "#FFFFFF",
    },
    "& i":{
        position: "absolute",
        height: "1px",
        width: "150%",
        background: "#FFFFFF"
    },
    "@media(max-width: 768px)": {
        height: "350px",
    },
});

const RoadmapElTop = styled(RoadmapElPrime)({
    borderBottom: "1px solid #FFFFFF",
    "&:before":{
        content: "' '",
        position: "absolute",
        bottom: "-40px",
        left: "calc(50% - 8px)",
        height: "17px",
        width: "17px",
        background: "#FFFFFF",
        borderRadius: "100%",
    },
    "&:after":{
        content: "' '",
        position: "absolute",
        bottom: "-30px",
        left: "50%",
        height: "30px",
        width: "1px",
        background: "#FFFFFF"
    },
    "& i":{
        bottom: "-33px",
        left: "50%",
    },
});

const RoadmapElBottom = styled(RoadmapElPrime)({
    borderTop: "1px solid #FFFFFF",
    "&:before":{
        content: "' '",
        position: "absolute",
        top: "-38px",
        left: "calc(50% - 8px)",
        height: "17px",
        width: "17px",
        background: "#FFFFFF",
        borderRadius: "100%",
    },
    "&:after":{
        content: "' '",
        position: "absolute",
        top: "-30px",
        left: "50%",
        height: "30px",
        width: "1px",
        background: "#FFFFFF"
    },
    "& i":{
        top: "-30px",
        left: "50%",
    }
});

const RoadmapElTitle = styled(Box)({
    whiteSpace: "break-spaces",
    fontSize: "1.5rem",
    textAlign: "center",
    fontWeight: 600,
    color: "#FFFFFF",
    zIndex: 2,
    textShadow: "1px 1px 2px black, 0 0 25px black, 0 0 5px black",
    "@media(max-width: 768px)":{
        fontSize: "1rem",
    },
});

const RoadmapElMenuContainer = styled("ul")({
    padding: "5px 20px 5px 30px",
    "@media(max-width: 768px)":{
        padding: "5px 10px 5px 20px",
    },
});

const RoadmapElMenuItem = styled("li")({
    fontSize: "1.3rem",
    fontWeight: 400,
    color: "#FFFFFF",
    zIndex: 2,
    textShadow: "1px 1px 2px black, 0 0 25px black, 0 0 5px black",
    "@media(max-width: 768px)": {
        fontSize: "0.8rem",
    },
});

const RoadmapEl = ({top, title, points}: RoadmapElInterface):JSX.Element => {
    
    const [anchorEl, setAnchorEl] = useState<null | HTMLAnchorElement>(null);
    
    const handleTeamOpen = (e: React.MouseEvent<HTMLAnchorElement>):void => {
        e.preventDefault();
        e.stopPropagation();
        setAnchorEl(e.currentTarget);
    };
    
    const renderPoint = (opt: string):React.ReactNode => {
        if(opt.includes("Hiring technical and financial specialists")){
            return <span>Hiring <a href={"#"} onClick={handleTeamOpen}>technical and financial specialists</a></span>;
        }
        return opt;
    };
    
    const renderContent = ():React.ReactNode => {
        if(top){
            return (
                <RoadmapElTop>
                    <RoadmapElTitle>
                        {title}
                    </RoadmapElTitle>
                    <ul>
                        {points.map((opt, index) => <li key={"RoadmapElTop-li-"+ "title"+ index}>
                            {renderPoint(opt)}
                        </li>)}
                    </ul>
                    <i/>
                </RoadmapElTop>
            );
        }
        return (
            <RoadmapElBottom>
                <RoadmapElTitle>
                    {title}
                </RoadmapElTitle>
                <ul>
                    {points.map((opt, index) => <li key={"RoadmapElTop-li-"+ "title"+ index}>
                        {opt}
                    </li>)}
                </ul>
                <i/>
            </RoadmapElBottom>
        );
    };
    
    
    return (
        <>
            {renderContent()}
            <Menu open={!!anchorEl} anchorEl={anchorEl} onClose={() => setAnchorEl(null)}>
                <RoadmapElMenuContainer>
                    {team.map((opt, index) => <RoadmapElMenuItem key={"RoadmapElMenuItem-" + index}>{opt}</RoadmapElMenuItem>)}
                </RoadmapElMenuContainer>
            </Menu>
        </>
    );
};

export default RoadmapEl;
